import { getLocations } from "@/api/metadata";
import { getOffers } from "@/api/offers";

const offers = {
  namespaced: true,
  state: {
    liveOffers: [],
    liveContracts: [],
    hasExistingContracts: false,
    haulageAvailableList: [],
    displayFilteredOffers: false,
    filtersApplied: [],
    deliveryLocations: [],
    basketRecommendations: [],
  },
  getters: {
    basketRecommendations(state) {
      return state.basketRecommendations;
    },
    liveOffers(state) {
      return state.liveOffers;
    },
    getLiveContracts: (state) => {
      return state.liveContracts;
    },
    getHasExistingContracts: (state) => {
      return state.hasExistingContracts;
    },
    deliveryLocations(state) {
      return state.deliveryLocations;
    },
    fuelsIds(state) {
      return state.fuelsIds;
    },
    haulageAvailableList(state) {
      return state.haulageAvailableList;
    },
  },
  mutations: {
    GET_OFFERS: (state, response) => {
      state.liveOffers = response ? response.sort((a, b) => {
        return a.price - b.price;
      }) : [];
    },
    SET_LIVE_CONTRACTS: (state, response) => {
      state.liveContracts = response;
    },
    SET_HAS_EXISTING_CONTRACTS: (state, response) => {
      state.hasExistingContracts = response;
    },
    GET_HAULAGE_LIST: (state, payload) => {
      state.haulageAvailableList = payload;
    },
    FILTER_OFFERS: (state, payload) => {
      state.filtersApplied = [];
      state.filtersApplied = payload.filtersApplied;

      /* If filters selected are the same as default, set displayFilteredOffers to false */
      if (payload.filtersSameAsDefault == false) {
        state.displayFilteredOffers = true;
      } else {
        state.displayFilteredOffers = false;
      }
    },
    GET_DELIVERY_LOCATIONS: (state, payload) => {
      state.deliveryLocations = payload;
    },
    SAVE_BASKET_RECOMMENDED: (state, payload) => {
      state.basketRecommendations = payload;
    },
    CLEAR_BASKET: (state) => {
      state.basketRecommendations = [];
    },
  },
  actions: {
    getOfferById: async ({ rootState, commit }, offerId) => {
      const response = await rootState.axios.get(`/api/offer/${offerId}`);
      return response;
    },
    getLiveOffers: async ({ commit }) => {
      // Get live offers
      const { offers, haulageOffers } = await getOffers();
      commit("GET_OFFERS", offers);
      commit("GET_HAULAGE_LIST", haulageOffers);
    },
    getLiveContractsList: async ({ commit, rootState }) => {
      const response = await rootState.axios.get("/api/getAllExistingContracts", {
        params: {
          onlyActive: false,
        },
      });

      if (response.data.success) {
        if (response.data.contracts.length > 0) {
          commit("SET_LIVE_CONTRACTS", response.data.contracts);
          commit("SET_HAS_EXISTING_CONTRACTS", true);
        } else {
          commit("SET_HAS_EXISTING_CONTRACTS", false);
        }
      }
    },
    getDeliveryLocations: async ({ rootGetters, commit }) => {
      const {
        data: { locations },
      } = await getLocations(rootGetters["login/getAccountId"]);
      if (locations) {
        commit("GET_DELIVERY_LOCATIONS", locations);
      }
    },
    getBasketRecommendations: async ({ rootState, commit }, data) => {
      await rootState.axios
        .get("/api/offers/recommended", { params: data })
        .then((res) => {
          commit("SAVE_BASKET_RECOMMENDED", res.data.body);
        })
        .catch((error) => {
          console.log("error", error);
        });
    },
    clearBasket: async ({ commit }) => {
      commit("CLEAR_BASKET");
    },
  },
};

export default offers;
